<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <h4>Rows: </h4>
        <div class="flexBreak"></div>
        <div class="formRow row childObject" v-for="(row, rowIndex) in $parent.mediaProperty.configuration.rows" :key="row.key">
            <div class="sequenceButtons" v-if="$parent.mediaProperty.configuration.rows.length > 1">
                <div class="sequenceMinusButton" @click="sequenceMinus(row, $parent.mediaProperty.configuration.rows)" v-if="row.sequence != 1">
                    <i class="fa-solid fa-angle-up"></i>
                </div>
                <div :style="{'margin-left': sequenceMargin(row.sequence)}">{{ row.sequence }}</div>
                <div class="sequencePlusButton" @click="sequencePlus(row, $parent.mediaProperty.configuration.rows)" v-if="row.sequence < $parent.mediaProperty.configuration.rows.length">
                    <i class="fa-solid fa-angle-down"></i>
                </div>
            </div>
            <div class="checkboxContainer">
                <p>Header Row</p>
                <input type="checkbox" @change="saveTable" v-model="row.isHeader" :disabled="!$parent.mediaProperty.isActive" />
            </div>
            <div class="checkboxContainer">
                <p>Footer Row</p>
                <input type="checkbox" @change="saveTable" v-model="row.isFooter" :disabled="!$parent.mediaProperty.isActive" />
            </div>
            <button class="deleteButton" @click="deleteRow(rowIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
            <div class="flexBreak"></div>
            <h4>Cells:</h4>
            <div class="flexBreak"></div>
            <div class="formRow cell grandChildObject" v-for="(cell, cellIndex) in row.cells" :key="cell.key">
                <div class="sequenceButtons" v-if="row.cells.length > 1" style="flex: 1 1 10%">
                    <div class="sequenceMinusButton" @click="sequenceMinus(cell, row.cells)" v-if="cell.sequence != 1">
                        <i class="fa-solid fa-angle-up"></i>
                    </div>
                    <div>{{ cell.sequence }}</div>
                    <div class="sequencePlusButton" @click="sequencePlus(cell, row.cells)" v-if="cell.sequence < row.cells.length">
                        <i class="fa-solid fa-angle-down"></i>
                    </div>
                </div>
                <button class="deleteButton" @click="deleteCell(rowIndex, cellIndex)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                <div style="flex: 1 1 20%">
                    <div class="checkboxContainer">
                        <p>Row Span</p>
                        <div>
                            <input type="number" @change="saveTable" v-model="cell.rowSpan" :disabled="!$parent.mediaProperty.isActive" />
                        </div>
                    </div>
                    <div class="checkboxContainer">
                        <p>Column Span</p>
                        <div>
                            <input type="number" @change="saveTable" v-model="cell.columnSpan" :disabled="!$parent.mediaProperty.isActive" />
                        </div>
                    </div>
                    <div class="checkboxContainer">
                        <p>Title Cell</p>
                        <div>
                            <input type="checkbox" @change="saveTable" v-model="cell.isTitle" :disabled="!$parent.mediaProperty.isActive" />
                        </div>
                    </div>
                    <div class="checkboxContainer">
                        <p>Total Cell</p>
                        <div>
                            <input type="checkbox" @change="saveTable" v-model="cell.isTotal" :disabled="!$parent.mediaProperty.isActive" />
                        </div>
                    </div>
                </div>
                <div style="flex: 1 1 60%">
                    <DisplayText :displayText="cell.displayText" :object="cell" :showLabel="false" :onChanged="saveTableText" :disabled="!$parent.mediaProperty.isActive"></DisplayText>
                </div>
                <TranslatedText v-if="cell.displayTextJson && cell.displayTextJson.length > 1"
                                :textJson="cell.displayTextJson"
                                position="bottom" alignment="start" :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
            </div>
            <div class="flexBreak"></div>
            <button class="addRowButton" @click="addCell(row)" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
        </div>
        <div class="flexBreak"></div>
        <button class="addRowButton" @click="addRow" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {translation} from '../../shared/translation';
import TranslatedText from '@/components/shared/TranslatedText.vue';
import DisplayText from '@/components/shared/DisplayText.vue';

export default {
    name: 'TableEdit',
    components: { TranslatedText, DisplayText },
    data: function() {
        return {
            rowKey: 0,
            cellKey: 0
        }
    },
    mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                rows: []
            }
        } else if(!this.$parent.mediaProperty.configuration.rows) {
            this.$parent.mediaProperty.configuration.rows = [];
        } else {
            let rows = this.$parent.mediaProperty.configuration.rows;
            rows.sort((a,b) => {return a.sequence - b.sequence;})
            rows.forEach(row => { 
                row.key = this.rowKey;
                this.rowKey++;
                row.cells.sort((a,b) => {return a.sequence - b.sequence;})
                row.cells.forEach(cell => {
                    cell.key = this.cellKey;
                    this.cellKey++;
                });
            });
        }
    },
    methods: {
        addRow: function() {
            const key = this.rowKey;
            this.rowKey++;
            const sequence = this.$parent.mediaProperty.configuration.rows.length ? 
                            this.$parent.mediaProperty.configuration.rows[this.$parent.mediaProperty.configuration.rows.length - 1].sequence + 1 :
                            1;
            this.$parent.mediaProperty.configuration.rows.push({key: key, sequence: sequence, cells: []});
        },
        addCell: function(row) {
            const key = this.cellKey;
            this.cellKey++;
            const sequence = row.cells.length ? row.cells[row.cells.length - 1].sequence + 1 : 1;
            row.cells.push({key: key, sequence: sequence, displayText: ''});
        },
        deleteRow: async function(rowIndex) {
            if(confirm('Are you sure you want to delete this row?')) {
                this.$parent.mediaProperty.configuration.rows.splice(rowIndex, 1);
                await this.saveTable();
            }
        },
        deleteCell: async function(rowIndex, cellIndex) {
            if(confirm('Are you sure you want to delete this cell?')) {
                this.$parent.mediaProperty.configuration.rows[rowIndex].cells.splice(cellIndex, 1);
                await this.saveTable();
            }
        },
        saveTableText: async function(cell, newValue, fieldName) {
            cell[fieldName] = newValue;
            this.saveTable(fieldName);
        },
        saveTable: async function(fieldName) {
            let rows = this.$parent.mediaProperty.configuration.rows;
            for(var i = 0; i < rows.length; i++) {
                if(!rows[i].cells.length) {
                    this.$toast.error('Every row must have at least 1 cell');
                    return;
                }

                for(var j = 0; j < rows[i].cells.length; j++) {
                    if(rows[i].cells[j].columnSpan === '') delete rows[i].cells[j].columnSpan;
                    if(rows[i].cells[j].rowSpan === '') delete rows[i].cells[j].rowSpan;

                    if(fieldName === 'displayText') {
                        rows[i].cells[j][fieldName + 'Json'] =
                            await translation.addTranslations(rows[i].cells[j][fieldName + 'Json'], 
                                        rows[i].cells[j][fieldName], this.$parent.mediaProperty.languages, this.$parent.mediaProperty.defaultLanguage);
                    }   

                }
            }

            const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
            if(!this.$parent.mediaProperty.id && resp.id) {
                this.$parent.mediaProperty.id = resp.id;
                this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
            }                
        },
        sequenceMinus: async function(obj, parentArr) {
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].sequence === (obj.sequence - 1)) {
                    parentArr[i].sequence++;
                    await this.saveTable();
                }
            }
            if(obj.sequence > 1) {
                obj.sequence--;
                await this.saveTable();
            }
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
        },
        sequencePlus: async function(obj, parentArr) {
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].sequence === (obj.sequence + 1)) {
                    parentArr[i].sequence--;
                    await this.saveTable(parentArr[i], 'sequence', false);
                }
            }
            if(obj.sequence < parentArr.length) {
                obj.sequence ++;
                await this.saveTable(obj, 'sequence');
            }
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
        },
        sequenceMargin: function(sequence) {
            if(sequence === 1)
                return '40px';
            else
                return '0px';
        },
        addLanguage: async function(lang) {
            for(var x = 0; x < this.$parent.mediaProperty.configuration.rows.length; x++) {
                for(var y = 0; y < this.$parent.mediaProperty.configuration.rows[x].cells.length; y++) {
                    if(this.$parent.mediaProperty.configuration.rows[x].cells[y].displayText) 
                        await translation.addTranslationToField(this.$parent.mediaProperty.configuration.rows[x].cells[y].displayTextJson, lang, this.$parent.mediaProperty.defaultLanguage, true);                   
                }
            }

            await this.saveTable();
        },
        deleteLanguage: async function(lang) {
            for(var x = 0; x < this.$parent.mediaProperty.configuration.rows.length; x++) {
                for(var y = 0; y < this.$parent.mediaProperty.configuration.rows[x].cells.length; y++) {
                    translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.rows[x].cells[y].displayTextJson, lang);
                }
            }

            await this.saveTable();
        }
    }
}

</script>

<style scoped>
    .row {
        margin-bottom: 10px;
    }
    input[type='number'] {
        padding: 2px 4px;
    }

    .configuration {
        display: flex;
        flex-wrap: wrap;
    }
    .row {
        flex: 1 0 600px;
        display: flex;
        flex-wrap: wrap;
    }
    .cell {
        min-height: 100px;
        flex: 1 0 600px;
        margin: 5px;
        padding: 10px;
    }
    textarea {
        width: 100%;
        min-height: 100px;
    }
    .sequenceButtons span{
        margin-left: 12px;
    }
    .sequenceButtons {
        display: flex;
        flex-direction: row;
        flex: 1 0 150px;
        font-size: 16px;
        height: 50px;
        align-items: center;
        justify-content: center;

    }
    .sequenceMinusButton {
        margin: 0 5px 0 0;
        padding: 1px 3px 0px 2px;
        width: 12px;
    }
    .sequencePlusButton {
        margin: 0 0 0 5px;
        padding: 1px 3px 0px 2px;
        width: 12px;
    }
    .checkboxContainer {
        flex: 1 1 200px;
        display: flex;
        flex-direction:right;
        padding-right: 20px;
    }

    .checkboxContainer p {
        flex: 1 1 60%;
        margin: 5px 0px;
    }

    .checkboxContainer div {
        flex: 1 1 40%;
        margin: auto;
    }
    .configuration .deleteButton {
        padding: 5px;
        background-color: #FFD831;
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
        bottom: unset;
        color: black;
        top: 10px;
        right: 10px;
    }
</style>